// extracted by mini-css-extract-plugin
module.exports = {"footer":"GardaWorldFooter_footer__qSDOg","logo":"GardaWorldFooter_logo__Nsqn9"};